<div>
  <nbc-alert></nbc-alert>
  <div class="page-container-tbl p-0" style="cursor:default;">
    <div class="container-fluid-tbl">
      <div class="row-tbl">
        <div class="box-dash">
          <div class="row">
            <div>
              <div class="header-bar clearfix">
                <button type="button" class="btn btn-primary pull-right talent-payroll-btncls" (click)="openCreateTemplateModal()" authenticate-user="position.create">+ Create Template</button>
              </div>
              <tpm-template-filter></tpm-template-filter>
              <tpm-template-list></tpm-template-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
